/**
 * Shared axios instance for /api/local/* calls. Attaches the JWT from
 * localStorage when present. Kept tiny — every screen imports this.
 */
import axios from "axios";

export const LOCAL_API = `${process.env.REACT_APP_BACKEND_URL}/api/local`;

export const localApi = axios.create({ baseURL: LOCAL_API, timeout: 30000 });

localApi.interceptors.request.use((cfg) => {
  const t = typeof window !== "undefined" ? localStorage.getItem("token") : null;
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Compensation model → human label.
export const COMPENSATION_LABEL = {
  free:             "Free",
  fixed_price:      "Fixed price",
  hourly:           "Hourly",
  negotiable:       "Negotiable",
  request_quote:    "Request quote",
  swap:             "Swap",
  donation:         "Donation",
  pay_what_you_can: "Pay what you can",
  volunteer:        "Volunteer",
  social_capital:   "Social Capital pts",
  free_plus_tip:    "Free + optional tip",
  cash_plus_swap:   "Cash + swap",
};

// Every listing type shipped in Phase 1.
export const LISTING_TYPES = [
  { key: "sell",                  label: "Sell",              intent: "offer",       needsPrice: true  },
  { key: "free",                  label: "Give away free",    intent: "offer",       needsPrice: false },
  { key: "wanted",                label: "Wanted",            intent: "request",     needsPrice: false },
  { key: "swap",                  label: "Swap",              intent: "request",     needsPrice: false },
  { key: "borrow",                label: "Borrow",            intent: "request",     needsPrice: false },
  { key: "lend",                  label: "Lend",              intent: "offer",       needsPrice: false },
  { key: "donate",                label: "Donate to charity", intent: "offer",       needsPrice: false },
  { key: "service_offer",         label: "Offer a service",   intent: "offer",       needsPrice: true  },
  { key: "service_request",       label: "Need a service",    intent: "request",     needsPrice: false },
  { key: "task_request",          label: "Post a task",       intent: "request",     needsPrice: true  },
  { key: "volunteer_opportunity", label: "Volunteer opportunity", intent: "opportunity", needsPrice: false },
  { key: "volunteer_request",     label: "Need a volunteer",  intent: "request",     needsPrice: false },
  { key: "community_help",        label: "Ask for community help", intent: "request", needsPrice: false },
  { key: "food_free",             label: "Share free food",   intent: "offer",       needsPrice: false },
  { key: "food_surplus",          label: "Post food surplus", intent: "offer",       needsPrice: true  },
  { key: "food_wanted",           label: "Need food",         intent: "request",     needsPrice: false },
  { key: "home_harvest",          label: "Home harvest",      intent: "offer",       needsPrice: false },
];

export function typeByKey(key) {
  return LISTING_TYPES.find((t) => t.key === key) || LISTING_TYPES[0];
}

export function formatMoney(minor, currency) {
  if (minor === null || minor === undefined) return null;
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency || "USD",
      minimumFractionDigits: 0,
    }).format(minor / 100);
  } catch {
    return `${(minor / 100).toFixed(2)} ${currency || ""}`;
  }
}
